import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { store, persistor } from './redux';
import { Provider } from 'react-redux';
import App from './App';
import '../src/assets/style/main.css';
import '../src/assets/style/index.css';
import 'react-chat-elements/dist/main.css';
import { ToastContainer } from 'react-toastify';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './config';
import { PersistGate } from 'redux-persist/integration/react';

const root = ReactDOM.createRoot(document.getElementById('root'));
export const msalInstance = new PublicClientApplication(msalConfig);
export const exportStore = store;

// eslint-disable-next-line no-undef
const staleTimeSec = parseInt(process.env.REACT_API_CACHE_TIME_SEC, 10) || 300; // Default to 5 minutes if not set

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            retry: false,
            staleTime: staleTimeSec * 1000, // Convert to milliseconds
        },
    },
});

root.render(
    <QueryClientProvider client={queryClient}>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <App instance={msalInstance} />
                <ToastContainer />
            </PersistGate>
        </Provider>
    </QueryClientProvider>,
);
